import { AppBar,  Box,  FormControlLabel,  IconButton, makeStyles, Menu, MenuItem, Switch, Toolbar, Tooltip, Typography } from '@material-ui/core'
import MenuIcon from '@material-ui/icons/Menu';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch ,useSelector } from 'react-redux';
import { editStatusAkses, getIzinAkses, setKonfigurasiNetwork, setLeftMenuOpen, setOpenHutang } from '../../../config/redux/action';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { useHistory } from 'react-router';
import Cookies from 'js-cookie';
import { apiUrl } from '../../../config';
import { ConnectionOff, ConnectionOn } from '../../assets';
import { addHours, format } from 'date-fns';
import { getIzinAksesKasir } from '../../../config/redux/action/penggunaAction';

const useStyles = makeStyles((theme)=>({
    grow:{
        flexGrow:2,
    },
    appbar:{
        position:'fixed',
        zIndex: theme.zIndex.drawer + 1
    },
    menuButton:{
        marginRight:theme.spacing(2),
    },
}));

const Banner = () => {
    const history = useHistory();
    const classes = useStyles();
    const [anchorEl,setAnchorEl] = useState(null);
    const isMenuOpen = Boolean(anchorEl);
    // const handleProfileMenuOpen=(event)=>{
    //     setAnchorEl(event.currentTarget);
    // };
    const handleMenuClose=()=>{
        setAnchorEl(null);
    }
    const [statusNetwork,setStatusNetwork] = useState(()=>{
        if(navigator.onLine){
            return true;
        }else{
            return false;
        }
    })
    const paramUrl = `${apiUrl.url}`;
    const dispatch= useDispatch();
    const {statusServer} = useSelector(state=>state.homeReducers);
    const checkOnlineStatus = useCallback(async () =>{
        try{
            const online = await fetch(paramUrl,{method:'HEAD',mode:'cors'})
            return online.status >= 200 && online.status < 300;
        }catch(err){
            return false;
        }
    },[paramUrl])
    useEffect(()=>{
        setInterval(async ()=>{
            const result = await checkOnlineStatus();
            if(result === true){
                setStatusNetwork(true);
                // dispatch(setKonfigurasiNetwork(true));
            }else{
                setStatusNetwork(false);
                // dispatch(setKonfigurasiNetwork(false));        
            }
        },500)
        if(statusServer!==statusNetwork){
            dispatch(setKonfigurasiNetwork(statusNetwork)); 
        }
    },[checkOnlineStatus,dispatch,statusServer,statusNetwork])

    //open drawer
    const {leftMenuOpen,openHutang} = useSelector(state => state.homeReducers);
    const {dataConfig}=useSelector(state=>state.configReducers);
    const {data}=useSelector(state=>state.loginReducers);
    const {izinAkses} = useSelector(state=>state.penggunaReducers);
    const [counter,setCounter]=useState(0);
    const [openToko,setOpenToko]=useState(false);
    const [labelOpen,setLabelOpen]=useState("Tutup Akses");
    const [token,setToken] = useState(data.token);
    const [level,setLevel]=useState(data.level);
    const [username,setUsername]=useState(data.username);
    if(token ===''){
        setToken(Cookies.get('u_tkn'));
    }
    if(level===''){
        setLevel(Cookies.get('level'));
    }
    if(username===''){
        setUsername(Cookies.get('u_name'));
    }
    const handleClick = () =>{
        dispatch(setLeftMenuOpen(!leftMenuOpen));
    }
    const menuId = 'primary-account-menu';
    useEffect(()=>{
        if(dataConfig===""){
            const dataCon=new URLSearchParams();
            dataCon.append('namaconfig',"IzinAkses");
            dispatch(getIzinAkses(dataCon,setOpenToko,setLabelOpen));
            dispatch(getIzinAksesKasir(username));
        }else if(dataConfig!==""){
            const result = addHours(new Date(dataConfig.waktu),8);
            const timeNow = format(new Date(),'yyyy-MM-dd HH:mm:ss');
            const finalHour = format(new Date(result),'yyyy-MM-dd HH:mm:ss');
            if(dataConfig.status==="Buka Akses" && timeNow>finalHour){
                const tempWaktu = new Date();
                const dataInput = new URLSearchParams();
                dataInput.append('status','Tutup Akses');
                dataInput.append('waktu',format(tempWaktu,'yyyy-MM-dd 00:00:00'))
                dispatch(editStatusAkses('IzinAkses',dataInput,token));
            }
        }
        if(level!=="Pemilik"){
            setTimeout(()=>{
                dispatch(getIzinAksesKasir(username));
                const dataCon=new URLSearchParams();
                dataCon.append('namaconfig',"IzinAkses");
                dispatch(getIzinAkses(dataCon,setOpenToko,setLabelOpen));
            },10000)
            if(dataConfig.status==="Tutup Akses"){
                Cookies.remove('username');
                Cookies.remove('u_tkn');
                Cookies.remove('identifier');
                history.push('/login');
            }
            if(izinAkses==="false"){
                Cookies.remove('username');
                Cookies.remove('u_tkn');
                Cookies.remove('identifier');
                history.push('/login');
            }
        }
    },[dispatch,dataConfig,dataConfig.status,token,history,level,izinAkses,username])
       
    const renderMenu=(
        <Menu
        anchorEl={anchorEl}
        anchorOrigin={{vertical:'bottom',horizontal:'right'}}
        id={menuId}
        keepMounted
        transformOrigin={{vertical:'top',horizontal:'right'}}
        open={isMenuOpen}
        onClose={handleMenuClose}
        >
            <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
        </Menu>
    )
    const handleLogOut=(e)=>{
        e.preventDefault();
        Cookies.remove('username');
        Cookies.remove('u_tkn');
        Cookies.remove('identifier');
        history.push('/login');
    }
    const handleClickConnection = () =>{
        setCounter(counter+1);
        if(counter===4){
            dispatch(setOpenHutang(!openHutang));
            setCounter(0);
        }
    }
    const handleCheckBukaToko = (e) =>{
        setOpenToko(e.target.checked);
        if(e.target.checked===true){
            setLabelOpen("Buka Akses");
            const tempWaktu = new Date();
            const dataInput = new URLSearchParams();
            dataInput.append('status','Buka Akses');
            dataInput.append('waktu',format(tempWaktu,'yyyy-MM-dd HH:mm:ss'))
            dispatch(editStatusAkses('IzinAkses',dataInput,token));
        }else if(e.target.checked===false){
            setLabelOpen("Tutup Akses")
            const tempWaktu = new Date();
            const dataInput = new URLSearchParams();
            dataInput.append('status','Tutup Akses');
            dataInput.append('waktu',format(tempWaktu,'yyyy-MM-dd 00:00:00'))
            dispatch(editStatusAkses('IzinAkses',dataInput,token));
        }
    }
    return (
        <div className={classes.grow}>
            <AppBar className={classes.appbar} position='static' style={{backgroundColor:'#b57535'} }>
                <Toolbar variant='dense'>
                    <IconButton
                    edge="start"
                    className={classes.menuButton}
                    color="inherit"
                    aria-label="open drawer"
                    onClick={handleClick}
                    >
                    <MenuIcon/>
                    </IconButton>
                <Typography variant="h5" noWrap>
                    Surya Harapan Furniture
                </Typography>
                {level==="Pemilik" ? 
                <FormControlLabel style={{marginLeft:'5px'}}
                    control={<Switch 
                    checked={openToko} 
                    onChange={handleCheckBukaToko} name="checkedB" color='primary' 
                    />}
                    label={labelOpen}
                />:null}
                <div className={classes.grow}/>
                <Typography>{localStorage.getItem('username')}</Typography>
                <Box sx={{display:'flex',alignItems:'center'}}>
                {statusNetwork ? 
                <img src={ConnectionOn} alt="on" style={{width:'15px',height:'15px',marginRight:'10px'}} onClick={handleClickConnection}/>:
                <img src={ConnectionOff} alt="on" style={{width:'15px',height:'15px',marginRight:'10px'}} onClick={handleClickConnection}/>}
                </Box>
                <Tooltip title="Logout">
                    <IconButton 
                    aria-label="logout actions" 
                    onClick={handleLogOut}
                    >
                        <ExitToAppIcon fontSize='default' style={{color:'white'}}/>
                    </IconButton>    
                </Tooltip>
                </Toolbar>
            </AppBar>
            {renderMenu}
        </div>
    )
}
export default Banner;
